import { DownloadOutlined } from '@ant-design/icons';
import { tran } from '@framework/engine/schema/translations/schema/TranslationSchema.ts';
import { type IWidgetType } from '@framework/engine/schema/widgets/IWidgetType.ts';
import {
  WidgetCategory,
  WidgetMainType,
} from '@framework/engine/schema/widgets/Widget.ts';
import { DownloadWidgetComponent } from './DownloadWidgetComponent.tsx';
import {
  DownloadWidgetConfigComponent,
  DownloadWidgetConfigSchema,
} from './DownloadWidgetConfigComponent.tsx';
import { type IDownloadWidget, WidgetDownloadType } from './IDownloadWidget.ts';

declare module '@framework/engine/schema/widgets/Widget.ts' {
  export enum WidgetType {
    Download = 'download',
  }
}

/**
 * Struttura del widget di download
 */
export const DownloadWidgetType: IWidgetType<IDownloadWidget> = {
  type: WidgetDownloadType,
  mainType: WidgetMainType.Graphic,
  category: WidgetCategory.Graphic,
  name: 'Download File',
  icon: <DownloadOutlined />,
  hasValue: false,
  formComponent: DownloadWidgetComponent,
  previewComponent: DownloadWidgetComponent,
  configValidator: DownloadWidgetConfigSchema,
  configComponent: DownloadWidgetConfigComponent,
  configOptions: {},
  // Traduzioni
  translationSchema: tran.widget({
    label: tran.rte(),
  }),
  rules: [],
};
